import noop from "lodash.noop";

/*
  Mobile safari will not trigger a hover/active event properly
  upon tapping the tooltip icon. This helps fix it.
  See: https://stackoverflow.com/questions/3885018/active-pseudo-class-doesnt-work-in-mobile-safari
*/
function fixMobileSafariTooltips(): void {
    window.addEventListener("touchstart", noop, false);

    window.onunload = function(): void {
        window.removeEventListener("touchstart", noop, false);
    };
}

export default fixMobileSafariTooltips;
